<template>
  <div>
    <home-header></home-header>
    <div class="wrapper pt-3">
      <div class="row">
        <div class="col">
          <div class="bg-white p-3 pb-0 mb-3">
            <el-form ref="form" :model="form" class="search-form" label-width="80px">
              <el-form-item label="搜索条件">
                <el-input placeholder="请输入内容" v-model="form.query" class="input-with-select">
                  <el-select v-model="form.query_field" slot="prepend" placeholder="请选择"
                             style="width: 103px;"
                             class="mobile-hidden">
                    <el-option label="公司名称" value="company_name"></el-option>
                    <el-option label="法人姓名" value="legal_person"></el-option>
                    <el-option label="经营范围" value="busi_scope"></el-option>
                    <el-option label="注册地址" value="address"></el-option>
                    <el-option label="企业代码" value="uni_code"></el-option>
                    <el-option label="行业" value="industry"></el-option>
                    <el-option label="经纬度" value="geo_distance"></el-option>
                  </el-select>
                </el-input>
                <el-button class="ml-2" type="primary" @click="btn_run_query">查看结果
                </el-button>
                <el-button @click="btn_cancel" class="mobile-hidden">重置选项</el-button>
              </el-form-item>

              <el-form-item label="行业" class="mobile-hidden">
                <el-cascader class="item_w"
                             v-model="form.indusList"
                             :options="indusList"
                             :show-all-levels="false"
                             :props="{ expandTrigger: 'hover',multiple: true, checkStrictly: true, value:'value',label:'label'}"
                             @change=""></el-cascader>

                <label class="item_label">成立日期</label>
                <el-date-picker v-model="form.date_range" type="monthrange" align="left" class="item_w"
                                unlink-panels range-separator="——" start-placeholder="开始"
                                end-placeholder="结束"
                                :picker-options="pickerOptions">
                </el-date-picker>
                <span class="pad-hidden">
                <label class="item_label">工商企业</label>
                  <!--
                  <el-select v-model="form.reg_status" clearable style="width:136px">
                    <el-option v-for="item in statusList" :key="item.value" :value="item.value">
                      {{ item.label }}
                    </el-option>
                  </el-select>
                  -->
                <el-switch v-model="form.entLive"></el-switch>
                  <label class="item_label">个体户</label>
                <el-switch v-model="form.entSep"></el-switch>
                  <label class="item_label">已注销</label>
                <el-switch v-model="form.entDie"></el-switch>
              </span>
              </el-form-item>

              <el-form-item label="省份">
                <el-select v-model="form.adProvs" placeholder="请选择省份" class="item_w" clearable multiple
                           v-on:change="getProv($event)">
                  <el-option v-for="item in provs" :key="item.value" :label="item.label"
                             :value="item.label">
                  </el-option>
                </el-select>

                <label class="item_label">企业规模</label>
                <el-select v-model="form.scaleList" clearable multiple placeholder="请选择" class="item_w">
                  <el-option v-for="item in scaleList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
                <span class="pad-hidden">
                <label class="item_label">风险信息</label>
                <el-select v-model="form.blots" clearable placeholder="请选择" class="item_w_200">
                  <el-option v-for="item in blotList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </span>
              </el-form-item>
              <!--
              <el-form-item label="地区" class="mobile-hidden">
                <div class="provs_left">
                  <el-checkbox-group v-model="form.adProvs">
                    <el-checkbox v-for="item in provs" :key="item.value" :label="item.label">
                      {{ item.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="provs_right">
                  <a @click="show_more()" href="javascript:void(0)">更多</a>
                </div>
              </el-form-item>
              -->
              <!--
              <el-form-item label="企业类型" class="mobile-hidden">
                <el-select v-model="form.std_type" clearable placeholder="请选择" class="item_w">
                  <el-option v-for="item in typeList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>

                <label class="item_label">城市</label>
                <el-select v-model="form.adCity" clearable placeholder="请选择城市" class="item_w">
                  <el-option v-for="item in citys" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>

                <label class="item_label">区</label>
                <el-select v-model="form.adDist" clearable placeholder="请选择城市" class="item">
                  <el-option v-for="item in citys" :key="item.value" :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>

                <label class="item_label">机构类型</label>
                <el-select v-model="form.tmpTag" clearable placeholder="请选择" class="item_w" learable
                           v-on:change="setTags($event)">
                  <el-option v-for="item in tagList" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              -->
              <el-form-item label="更多筛选" class="mobile-hidden mt-2">
                <el-dropdown trigger="click" @command="drop_change">
                <span class="el-dropdown-link">
                  知识产权<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="有专利">有专利</el-dropdown-item>
                    <el-dropdown-item command="软著权">软件著作权</el-dropdown-item>
                    <el-dropdown-item command="作品著作权">作品著作权</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="click" @command="drop_change">
                <span class="el-dropdown-link">
                  融资信息<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="天使轮">天使轮</el-dropdown-item>
                    <el-dropdown-item command="PreA至A">PreA至A</el-dropdown-item>
                    <el-dropdown-item command="PreB至B">PreB至B</el-dropdown-item>
                    <el-dropdown-item command="C轮及以上">C轮及以上</el-dropdown-item>
                    <el-dropdown-item command="股权融资或转让">股权融资或转让</el-dropdown-item>
                    <el-dropdown-item command="IPO上市">IPO上市</el-dropdown-item>
                    <el-dropdown-item command="并购合并">并购合并</el-dropdown-item>
                    <el-dropdown-item command="定向增发">定向增发</el-dropdown-item>
                    <el-dropdown-item command="战略投资">战略投资</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="click" @command="drop_change">
                <span class="el-dropdown-link">
                  上市公司<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A股">A股上市</el-dropdown-item>
                    <el-dropdown-item command="中概股">中概股</el-dropdown-item>
                    <el-dropdown-item command="港股">港股上市</el-dropdown-item>
                    <el-dropdown-item command="科创板">科创板</el-dropdown-item>
                    <el-dropdown-item command="新三板">新三板</el-dropdown-item>
                    <el-dropdown-item command="新四板">新四板</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <span class="pad-hidden">
                <el-dropdown trigger="click" @command="drop_change">
                  <span class="el-dropdown-link">
                    排行榜<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="世界500强">《财富》世界500强</el-dropdown-item>
                    <el-dropdown-item command="中国500强">《财富》中国500强</el-dropdown-item>
                    <el-dropdown-item command="民企500强">中国民营企业500强</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>

                <span class="pad-hidden">
                <el-dropdown trigger="click" @command="drop_change">
                  <span class="el-dropdown-link">
                    机构类型<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="事业单位">事业单位</el-dropdown-item>
                    <el-dropdown-item command="社会团体">社会团体</el-dropdown-item>
                    <el-dropdown-item command="基金会">基金会</el-dropdown-item>
                    <el-dropdown-item command="律师事务所">律师事务所</el-dropdown-item>
                    <el-dropdown-item command="会计师事务所">会计师事务所</el-dropdown-item>
                    <el-dropdown-item command="普通合伙">普通合伙</el-dropdown-item>
                    <el-dropdown-item command="有限合伙">有限合伙</el-dropdown-item>
                    <el-dropdown-item command="学校">学校</el-dropdown-item>
                    <el-dropdown-item command="机关单位">机关单位</el-dropdown-item>
                    <el-dropdown-item command="医疗机构">医疗机构</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>

                <el-dropdown trigger="click" @command="drop_change">
                <span class="el-dropdown-link">
                  科技型企业<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,k) in techList" :key="k" :command="item.value">{{
                        item.value
                      }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown trigger="click" @command="drop_change">
                <span class="el-dropdown-link">
                  其他标签<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="纳税A级">纳税A级</el-dropdown-item>
                    <el-dropdown-item command="招投标">有招投标</el-dropdown-item>
                    <el-dropdown-item command="外商投资企业">外商投资企业</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

                <el-tag v-for="(tag,k) in form.tags" :key="tag" class="ml-2"
                        type="danger" closable @close="remove_tag(tag)">
                  {{ tag }}
                </el-tag>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header">
              <div style="float:left;margin-top: 5px;">为你找到
                <font style="color:red;">{{ this.page.total }} </font>
                <span>家符合条件的企业</span>
              </div>
              <div style="float:right">
                支持批量导出&nbsp;&nbsp;<el-button size="small" type="danger" @click="btn_export_data">导出数据
              </el-button>
              </div>
            </div>
            <div id="mapContainer" class="bg-white p-3 mb-3 search_list">
              <div v-if="listLoading" class="item">
                <div class="h-420">
                  <div class="loading_position">
                    <i class="el-icon-loading"
                       style="font-size: 25px;margin-left: 10px;margin-bottom: 10px;"></i>
                    <span class="d-block">加载中...</span>
                  </div>
                </div>
              </div>
              <div v-else-if="dataList.length == 0">
                <div class="h-435">
                  <div class="loading_position">
                    <span class="d-block">无数据，请重试</span>
                  </div>
                </div>
              </div>
              <ent-list :dataList="dataList"></ent-list>
              <el-pagination layout=" prev, pager, next" @current-change="handleCurrentChange"
                             :page-size="this.page.size" :total="this.page.total"
                             :current-page="this.page.index+1">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <export-data :dlg_export_model="dlg_export_model" :form="form"
                   @exportClose="dlg_export_model=false"></export-data>
    </div>
    <home-footer></home-footer>
  </div>
</template>

<script>
import api from "../../api/rest";
import util from "../../api/util"
import { eventBus } from '../../api/event-bus.js';
import EntList from "../../components/EntList";
import ExportData from "../../components/ExportData.vue";
import HomeHeader from "../../components/HomeHeader.vue";
import HomeFooter from "../../components/HomeFooter.vue";

export default {
  name: "charts",
  components: {HomeFooter, HomeHeader, ExportData, EntList},
  data() {
    return {
      dataList: [],
      listLoading: true,
      techList: util.setting.getTechList(),
      info: [],
      dlg_export_model: false,
      dlg_login_model: false,
      folderList: [],
      form: {
        adProv: '',
        adCity: '',
        adDist: '',
        date_range: [],
        query: "",
        legal_person: "",
        indusList: [],
        indus: '',
        scaleList: [],
        adProvs: [],
        date_field: "reg_date",
        std_type: "",
        scale: "",
        entLive: true,
        entDie: false,
        entSep: false,
        order: "cnt_v",
        tags: [],
        query_field: "company_name",
        idx: 'ent',
      },
      page: {
        total: 0,
        index: 0,
        size: 10,
      },
      provs: util.setting.getProvs_slim(),
      prov_sime: true,
      citys: [],
      userInfo: "",
      checkAll: false,
      typeList: util.setting.getEntTypeList(),
      scaleList: util.setting.getEntScaleList(),
      indusList: util.setting.getIndustry(),
      blotList: [{
        label: "动产抵押",
        value: "动产抵押"
      }, {
        label: "股权出质",
        value: "股权出质"
      }, {
        label: "股权冻结",
        value: "股权冻结"
      }, {
        label: "经营异常",
        value: "经营异常"
      }, {
        label: "严重违法",
        value: "严重违法"
      }, {
        label: "税收违法",
        value: "税收违法"
      }, {
        label: "行政处罚",
        value: "行政处罚"
      }],
      tagList: [{
        label: "律师事务所",
        value: "律师事务所"
      }, {
        label: "会计师事务所",
        value: "会计师事务所"
      }, {
        label: "学校",
        value: "学校"
      }, {
        label: "医疗机构",
        value: "医疗机构"
      }, {
        label: "机关单位",
        value: "机关单位"
      }],
      statusList: [{
        label: "存续",
        value: "存续"
      }, {
        label: "注销",
        value: "注销"
      }, {
        label: "吊销，未注销",
        value: "吊销，未注销"
      }, {
        label: "吊销",
        value: "吊销"
      }, {
        label: "吊销，已注销",
        value: "吊销，已注销"
      }],
      isIndeterminate: true,
      pickerOptions: util.setting.getPickerDateOpt(),
      birthOptions: util.setting.getPickeAgeOpt(),
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    show_more() {
      if (this.prov_sime == true) {
        this.provs = util.setting.getProvs()
        this.prov_sime = false
      } else {
        this.provs = util.setting.getProvs_slim()
        this.prov_sime = true
      }
    },
    // 将省份名称变成省份简称
    getProvName(name) {
      for (var prov of this.provs) {
        if (name == prov.label) {
          return prov.value
        }
      }
    },
    getProv: function (prov) {
      prov = this.getProvName(prov)
      let tempCity = [];
      this.citys = [];
      let allCity = util.setting.getCity()
      for (var val of allCity) {
        if (prov === val.prov) {
          tempCity.push({
            label: val.label,
            value: val.label
          });
        }
      }
      this.citys = tempCity;
    },
    setTags: function (tags) {
      this.form.tags = []
      this.form.tags.push(tags)
    },
    drop_change(val) {
      this.form.tags = []
      if (this.form.tags.includes(val) == false) {
        this.form.tags.push(val)
      }
      this.btn_run_query()
    },
    remove_tag(tag) {
      const idx = this.form.tags.indexOf(tag)
      if (idx > -1) {
        this.form.tags.splice(idx, 1)
      }
      this.btn_run_query()
    },
    btn_export_data() {
      if (api.storage.get('user') == null) {
        // 发送需要登录消息
        eventBus.$emit('event_loginRequire', 'true');
      } else {
        this.form.total = this.page.total
        this.form.totalAmount = this.page.total / 100
        this.dlg_export_model = true;
      }
    },
    getFolderList() {
      let para = this.page
      para.type = 'ent'
      let api_url = "/folder/list"
      api.remote.doPost(para, api_url).then((res) => {
        this.folderList = res.content;
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    btn_cancel(val) {
      this.form = {
        query: "",
        adProv: "",
        adCity: '',
        adDist: '',
        date_range: [],
        name: "",
        legal_person: "",
        date_field: "reg_date",
        std_type: "",
        scale: "",
        indusList: [],
        indus: '',
        adProvs: [],
        scaleList: [],
        tags: [],
        entLive: true,
        entDie: false,
        entSep: false,
        order: "cnt_v",
        query_field: "company_name"
      }
    },

    search_action() {
      this.listLoading = true;
      this.dataList = []
      let para = {
        ...this.form,
        ...this.page
      }
      api.slice.entQuery(para).then((res) => {
        if (res.status == "error") {
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
        }
        this.dataList = res.content;
        this.page.total = res.totalElements
        this.listLoading = false;
      }).catch((res) => {
        this.listLoading = false;
        api.handError.action(this, res);
      });
    },
    btn_run_query() {
      this.page.index = 0;
      this.search_action()
    },
    handleCurrentChange(val) {
      this.page.index = val - 1;
      this.search_action();
    },
    set_map_height() {
      const myDiv = document.getElementById('mapContainer');

      function setDivHeight() {
        const windowHeight = window.innerHeight;
        myDiv.style.minHeight = windowHeight - 470 + "px"
      }

      window.addEventListener('resize', setDivHeight);
      setDivHeight();
    },
  },
  mounted() {
    this.set_map_height()
    var today = new Date();
    if (this.$route.query.keyword != null) {
      this.form.query = decodeURI(this.$route.query.keyword)
    }
    if (this.$route.query.tags != null) {
      this.form.tags.push(decodeURI(this.$route.query.tags))
    }
    if (this.$route.query.portray != null) {
      this.form.portray = decodeURI(this.$route.query.portray)
    }

    // let module_name = this.$route.path.replace('/', '')
    // api.storage.set('active_module', module_name)
    // this.$bus.emit('changeMsg', module_name);
    this.search_action()
    // this.getFolderList()
  }
}
</script>



// WEBPACK FOOTER //
// Result.vue?375ac166